import embedService from '@/embed/embedService'

export function isDevelopment(): boolean {
  return import.meta.env.DEV
}

export function isStaging(): boolean {
  return (
    window.location.host === 'staging.rq.app' ||
    embedService.getCurrentScriptHostname() === 'staging.rq.app'
  )
}

export function isFeature(): boolean {
  return (
    window.location.host === 'feature.rq.app' ||
    embedService.getCurrentScriptHostname() === 'feature.rq.app'
  )
}

export function isPreProduction(): boolean {
  return (
    window.location.host === 'pre-prod.rq.app' ||
    embedService.getCurrentScriptHostname() === 'pre-prod.rq.app'
  )
}

export function isProduction(): boolean {
  return (
    window.location.host === 'refer.rq.app' ||
    embedService.getCurrentScriptHostname() === 'refer.rq.app'
  )
}

export function isDocker(): boolean {
  const hostUrl = `${window.location.protocol}//${window.location.host}`

  return hostUrl.includes('host.docker.internal')
}

export function isNotProduction(): boolean {
  return !isProduction()
}

const ORIGINS = {
  production: 'https://refer.rq.app',
  preProduction: 'https://pre-prod.rq.app',
  staging: 'https://staging.rq.app',
  feature: 'https://feature.rq.app',
  development: 'https://app.rqratings.dev',
}

export function getAppUrl() {
  switch (true) {
    case isProduction():
      return ORIGINS.production
    case isPreProduction():
      return ORIGINS.preProduction
    case isStaging():
      return ORIGINS.staging
    case isFeature():
      return ORIGINS.feature
    default:
      return ORIGINS.development
  }
}

const AUTH_ORIGINS = {
  production: 'https://auth.refer.rq.app',
  preProduction: 'https://auth-pre-prod.rq.app',
  staging: 'https://auth-staging.rq.app',
  feature: 'https://auth-feature.rq.app',
  development: 'https://auth.rqratings.dev',
}

export function getAuthUrl() {
  switch (true) {
    case isProduction():
      return AUTH_ORIGINS.production
    case isPreProduction():
      return AUTH_ORIGINS.preProduction
    case isStaging():
      return AUTH_ORIGINS.staging
    case isFeature():
      return AUTH_ORIGINS.feature
    default:
      return AUTH_ORIGINS.development
  }
}
